import { Component, Vue } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { IWinnersTrackerService, ITrackedWinner } from '@/components/game/_domain/modules/winners-tracker-service';
import { PrizeHelper } from '@/components/game/_domain/helpers/prize-helper';
import { IServerServiceFactory, ServerServiceSubscriptionStore } from '@/app-modules/server-service';
import { ArcadeWinnerMessageResponse } from '@/components/chat/_domain';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IArcadeAdminFeedServiceProvider } from '@/components/chat/_domain/modules/arcade-admin-feed-service-provider';
import { GameLocalisation } from '@/components/game/_domain/modules/game-localisation';
import { IConfigurationService, IChatModsConfiguration, ConfigurationPaths } from '@/app-modules/config';

@Component({
  name: 'GameWinnersWinnersViewComponent'
})
export default class GameWinnersWinnersViewComponent extends TombolaBaseComponent {
  private trackedWinners: ITrackedWinner[] = [];
  private isWinnersTrackingFrozen: boolean = false;
  private adminFeedSubscriptionStore: ServerServiceSubscriptionStore = null;
  public prizeHelper: PrizeHelper = new PrizeHelper();
  private gameLocalisation: GameLocalisation = new GameLocalisation(this.$lang);
  private chatModConfig: IChatModsConfiguration = null;

  private get winnersTrackerService(): IWinnersTrackerService {
    return this.$container.get(SERVICE_IDENTIFIERS.IWinnersTrackerService);
  }

  private get serverServiceFactory(): IServerServiceFactory {
    return this.$container.get(SERVICE_IDENTIFIERS.IServerServiceFactory) as IServerServiceFactory;
  }

  private get arcadeAdminFeedProvider(): IArcadeAdminFeedServiceProvider {
    return this.$container.get(SERVICE_IDENTIFIERS.IArcadeAdminFeedServiceProvider);
  }

  private async getChatModsConfiguration(): Promise<IChatModsConfiguration> {
    const configurationService: IConfigurationService = this.$container.get(SERVICE_IDENTIFIERS.IConfigurationService);
    return await configurationService.getConfiguration();
  }

  private useSkinName(): boolean {
    return this.chatModConfig && this.chatModConfig.getConfigurationByPath(ConfigurationPaths.featuretoggle.use_skin_name_in_gamename_islive) === 'true';
  }

  private updated() {
    const scrollableContainer: any = this.$refs.scrollableContainer;
    if (scrollableContainer) {
      scrollableContainer.scrollToBottom();
    }
  }

  private async mounted() {
    this.chatModConfig = await this.getChatModsConfiguration();
    this.trackedWinners = this.winnersTrackerService.getAllTrackedWinners();
    this.isWinnersTrackingFrozen = this.winnersTrackerService.isFrozen();
    Vue.nextTick(() => this.subscribeAdminFeedWinners());
  }

  private beforeDestroy() {
    this.unsubscribeAdminFeedWinners();
  }

  private subscribeAdminFeedWinners(): void {
    const server = this.arcadeAdminFeedProvider.getAdminFeedService();
    this.adminFeedSubscriptionStore = new ServerServiceSubscriptionStore(
      server.subscribeArcadeWinnerMessage(this.populateArcadeWinners)
    );
  }

  private populateArcadeWinners(payload: ArcadeWinnerMessageResponse) {
    const winner: ITrackedWinner = {
      gameName: payload.game,
      skinName: this.useSkinName() ? payload.skinname : null,
      username: payload.username,
      prizeInPence: payload.prize
    };

    this.winnersTrackerService.trackWinners(winner);
  }

  private unsubscribeAdminFeedWinners() {
    if (this.adminFeedSubscriptionStore) {
      this.adminFeedSubscriptionStore.unsubscribeAll();
      this.adminFeedSubscriptionStore = null;
    }
  }

  private getFormatedGameNameForTrackedWinner(trackedWinner: ITrackedWinner): string {
    if (trackedWinner.skinName) {
      return this.gameLocalisation.getLocalGameName(trackedWinner.gameName, this.useSkinName() ? trackedWinner.skinName : null);
    } else {
      const formattedClubName = trackedWinner.clubName && trackedWinner.clubName !== trackedWinner.gameName ? `(${trackedWinner.clubName})` : '';
      return `${trackedWinner.gameName} ${formattedClubName}`.trim();
    }
  }

  private getFormattedPrizeValueForTrackedWinner(trackedWinner: ITrackedWinner): string {
    return this.prizeHelper.formatPrize(trackedWinner.prizeInPence);
  }

  private toggleWinnersTrackingFrozen(): void {
    this.isWinnersTrackingFrozen = !this.isWinnersTrackingFrozen;
    if (this.isWinnersTrackingFrozen) {
      this.winnersTrackerService.freeze();
    }
    else {
      this.winnersTrackerService.unfreeze();
    }
  }

  private copyTrackedWinner(trackedWinner: ITrackedWinner): void {
    this.winnersTrackerService.copyTrackedWinnerToClipboard(trackedWinner);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game-winners/_components/game-winners/game-winners.winners-view.component.ts